var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h2',[_vm._v("HMI COORDINATING OFFICES")]),_c('h4',[_vm._v(" Satellite HMI Offices where members may proceed to secure required forms for approval, consult, medical advice. Kindly see the back cover for locations and contact information. ")])])
}]

export { render, staticRenderFns }